module.exports = __webpack_public_path__ + "img/brandImg4.db847ba2.jpg";